module.exports = __webpack_public_path__ + "static/media/directbox-receive.c1d7f9fc.svg";